/* eslint-disable no-param-reassign */
export default {
  namespaced: true,
  state: {
    pets: [],
  },
  getters: {
    get: (state) => state.pets,
  },
  mutations: {
    insert(state, payload) {
      state.pets = payload
    },
    deletePet(state, petId) {
      const index = state.pets.findIndex((pet) => pet.id === petId)

      state.pets.splice(index, 1)
    },
    updatePet(state, payload) {
      state.pets = state.pets.map((pet) => {
        return pet.id === payload.id ? payload : pet
      })
    },
  },
}
